import { render } from "./Overlays.htm?vue&type=template&id=27d154ac&scoped=true&ts=true"
import script from "./Overlays.vue?vue&type=script&lang=ts"
export * from "./Overlays.vue?vue&type=script&lang=ts"

import "./Overlays.scss?vue&type=style&index=0&id=27d154ac&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d154ac"]])

export default __exports__